import { optionsFull_subCategory_error } from './OptionsPaneError.locstring.json';
import loc from 'owa-localize';

import { observer } from 'mobx-react-lite';
import * as React from 'react';

const styles = require('./OptionsPaneError.scss');

export default observer(function OptionsPaneError(props: {}) {
    return <div className={styles.messageContainer}>{loc(optionsFull_subCategory_error)}</div>;
});
